import { createFileRoute } from '@tanstack/react-router';
import { MyTicketsPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/my-tickets')({
  component: MyTicketsPage,
});
